import React from 'react';

import CartButtom from '../cart-button/cart-button.component';

import Veg from '../../assets/icon-veg.svg';
import Nonveg from '../../assets/icon-non-veg.svg';
import noImage from '../../assets/food-placeholder.jpg';

import './menu-items.style.css';

class menuItems extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            exp: true
        }
        this.explain = this.explain.bind(this);
    }

    explain() {
        if (this.state.exp) {
            this.setState({
                exp: false
            });
        }
        else {
            this.setState({
                exp: true
            })
        }
    }

    render() {
        const { item_name, description, image_url, price, food_type } = this.props;
        var res = '';
        if (description !== null && description !== '') {
            res = description.slice(0, 60) + "...";
        }
        return (
            <div className='uk-flex uk-flex-between menu-items-container'  >
                <div className='menu-items' >
                    <div className="menu-items-img-container" >
                        <img src={image_url ? image_url : noImage} alt="thali" className="menu-items-img" />
                    </div>
                    <div className="menu-items-left">
                        <div className='uk-flex uk-flex-left uk-text-middle'>

                            {food_type === "1" &&
                                <img src={Veg} className="menu-items-veg-img" alt="veg" />
                            }

                            {food_type === "2" &&
                                <img src={Nonveg} className="menu-items-veg-img" alt="nonveg" />
                            }

                            <p className='uk-margin-remove menu-items-name'>{item_name}</p>
                        </div>
                        <p onClick={this.explain} className='uk-margin-remove uk-text-light menu-items-desc' >{this.state.exp ? res : description}</p>
                        <p className='uk-margin-remove menu-items-price' ><span>₹</span>{price}</p>
                    </div>

                </div>
                <CartButtom item={this.props} />
            </div>
        )
    }
}

export default menuItems;